module.exports = __webpack_public_path__ + "img/plan1.cf64e6e8.svg";